import React from 'react';
import { Col, Row, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import AWSSelectorContainer from './../Containers/AWSSelectorContainer';
import AWSInstancesTableComponent from './../Components/AWSInstancesTableComponent';

const generateLabel = (syncTime) =>
{
  return 'Latest Sync: ' + syncTime;
};

const AWSInstancesCostComponent = ({
  onFetch,
  onSort,
  instancesGroupById,
  syncStatus,
  latestSyncDatetime
}) => (
  <div>
    <Row style={{ margin: 0 }}>
      <Col sm={12} md={12} mdOffset={1} style={{ padding: 0 }}>
        <Row style={{ marginBottom: '30px' }}>
          <Col md={1}>
            <Button
              id="button-sync"
              onClick={onFetch}
              disabled={syncStatus}
              className="sync-button"
            >
              { syncStatus ? 'Syncing Data, please wait...' : 'AWS Data Sync'}
            </Button>
          </Col>
          { !syncStatus && <Col>
            {generateLabel(latestSyncDatetime)}
          </Col>}
        </Row>
        <Row style={{ marginBottom: '15px' }}>
          <Col xs={12}>
            <AWSSelectorContainer />
          </Col>
        </Row>
        <Row>
          <Col xs={10}>
            <AWSInstancesTableComponent
              instances={instancesGroupById}
              onSort={onSort}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  </div>
);

AWSInstancesCostComponent.propTypes = {
  onFetch: PropTypes.func.isRequired,
  onSort: PropTypes.func.isRequired,
  instancesGroupById: PropTypes.objectOf(PropTypes.arrayOf(Object)).isRequired,
  syncStatus: PropTypes.bool.isRequired,
  latestSyncDatetime: PropTypes.string.isRequired
};

export default AWSInstancesCostComponent;


// WEBPACK FOOTER //
// src/Components/AWSInstancesCostComponent.jsx